import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { ITipsBreakdownLineItem } from 'screens/MakePayment/Calculator/types';
import { centsToDollarsDisplay } from 'utils/currency';
import LineItem from './LineItem';

interface IReceivingBreakdownProps {
  className?: string;
  dataCy?: string;
  values: ITipsBreakdownLineItem[];
}

const Col = styled.div`
  @media (max-width: ${theme.breakpoint.small}) {
    &:not(:first-child),
    &:not(:last-child) {
      display: none;
    }
  }
`;

const ReceivingBreakdownLayout = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: ${toRem(12)};
  color: ${theme.color.neutral[900]};

  &:not(:last-child) {
    margin-bottom: ${toRem(8)};
  }
`;

const HeaderRow = styled(Row)`
  font-size: ${toRem(12)};
  color: ${theme.color.neutral[500]};
  font-weight: ${theme.font.weight.medium};
`;

const TotalRow = styled(Row)`
  font-weight: ${theme.font.weight.bold};
`;

const ReceivingBreakdown: React.FC<IReceivingBreakdownProps> = ({ className = '', dataCy = 'employee-receiving-tips-breakdown', values }) => {
  const renderLineItems = () => (values || []).map((value, i) => <LineItem key={`${value.label}_${i}`} item={value} dataCy={`${dataCy}-line-item`} />);

  return (
    <ReceivingBreakdownLayout className={className} data-cy={dataCy}>
      <HeaderRow data-cy={`${dataCy}-header`}>
        <Col>Receiving From</Col>
        <Col>Amount</Col>
      </HeaderRow>
      {renderLineItems()}
      <TotalRow data-cy={`${dataCy}-total`}>
        <Col>Total</Col>
        <Col>{centsToDollarsDisplay((values || []).reduce((acc, curr) => acc + curr.amount, 0))}</Col>
      </TotalRow>
    </ReceivingBreakdownLayout>
  );
};

export default ReceivingBreakdown;
